module.exports = __webpack_public_path__ + "static/assets/ecf8aab29858b1233a5214116e8da517.png";